import React, { FC, ReactNode } from "react"
// eslint-disable-next-line no-restricted-imports -- FIXME: Usages of styled-components should be replaced with components from carotene-core or carotene-core-x. Please do not import styled-components after eslint rule added on 3/21/2025.
import styled from "styled-components"
import colors from "#/css/variables/_colors.module.scss"
import { PiiText } from "#/services/tracking"
import { Box, Typography } from "@carrotfertility/carotene-core"

const DetailsList = styled.div`
  inline-size: 100%;
  background-color: rgba(255, 255, 255, 0.3);
  padding: 16px;
  border-block-end: 1px solid ${colors.mint};
  border-block-start: 1px solid ${colors.mint};
`

const StyledDetailsListItem = styled.div`
  padding: 8px 0;
  border-block-end: 1px solid ${colors.mintAlternate};
  &:last-child {
    border-block-end: none;
  }
`

type DetailsListItemProps = {
  header: string
  body: ReactNode
}

const DetailsListItem: FC<DetailsListItemProps> = ({ header, body }) => (
  <StyledDetailsListItem>
    <Typography variant="overline">{header}</Typography>
    <Box sx={(theme) => ({ marginBlockStart: theme.tokens.spacing.xxxs })}>
      <Typography variant="body2">
        <PiiText>{body}</PiiText>
      </Typography>
    </Box>
  </StyledDetailsListItem>
)

export { DetailsList, DetailsListItem }
